export enum HttpStatus {
  NOT_FOUND = 404,
  FORBIDDEN_ACCESS = 403,
  UNAUTHORIZED = 401,
}
